import classNames from 'classnames';
import type { FC, ReactNode, JSX } from 'react';
import type { TitleProps } from './Title.props';

const size = new Map<ReactNode, string>();
size.set('h1', 'text-7xl');
size.set('h2', 'text-6xl');
size.set('h3', 'text-5xl');
size.set('h4', 'text-4xl');
size.set('h5', 'text-3xl');
size.set('h6', 'text-2xl');

const Title: FC<TitleProps> = ({
  children,
  type: Type,
  className,
}): JSX.Element => {
  return (
    <Type
      className={classNames(
        'font-degular text-primary font-bold',
        size.get(Type),
        className,
      )}
    >
      {children}
    </Type>
  );
};

export default Title;
